import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const Home = () => {
  // useEffect(() => {
  //   window.location.href = "https://masirat.com/pharmacy-software-2-2/";
  // }, []);

  return <Navigate to={"/signin"} />;
};

export default Home;
